module.exports = __webpack_public_path__ + "img/girl@2x.aafded94.png";